<div class="extensions-container">
    <div class="page-top-banner">
        <div class="title">Groupes d’extensions</div>
        <div class="action-zone">
            <mat-form-field appearance="fill" style="width: 100%;">
                <mat-label>Plateforme :</mat-label>
                <mat-select [(ngModel)]="platform" (ngModelChange)="onPlatformChange()">
                    <mat-option value="Centrex NG">Centrex NG</mat-option>
                    <mat-option value="Centrex Enreach">Centrex Enreach</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="table-container">
        <form class="filters-form" [formGroup]="filtersForm">
            <div class="mat-elevation-z8 general-table">
                <table mat-table class="default-table" [dataSource]="dataSource" matSort>
                    <!-- Extension -->
                    <ng-container matColumnDef="extension">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Extension</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="extension" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="resetColumnFilter('extension')"><mat-icon>clear</mat-icon></button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let ext">{{ ext.number }}</td>
                    </ng-container>

                    <!-- Nom -->
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Nom</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="name" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="resetColumnFilter('name')"><mat-icon>clear</mat-icon></button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let ext">{{ ext.name }}</td>
                    </ng-container>

                    <!-- Membres -->
                    <ng-container matColumnDef="members">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Membres</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="members" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('members')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let ext">
                            @for (member of getMemberNames(ext); track $index) {
                            <div>{{ member }}</div>
                            }
                        </td>
                    </ng-container>

                    <!-- Site -->
                    <ng-container matColumnDef="siteId">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Site</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="siteId" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix (click)="resetColumnFilter('siteId')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                </mat-form-field>
                            </div>
                        </th>

                        <td mat-cell *matCellDef="let element">
                            {{ element.siteName || '—' }}
                        </td>
                    </ng-container>

                    <!-- Distribution -->
                    <ng-container matColumnDef="distribution">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>Distribution</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="distribution" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="resetColumnFilter('distribution')"><mat-icon>clear</mat-icon></button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let ext">
                            {{ getDialerTypeLabel(ext.dialerType) }}
                        </td>
                    </ng-container>

                    <!-- SDA -->
                    <ng-container matColumnDef="sda">
                        <th mat-header-cell *matHeaderCellDef>
                            <span mat-sort-header>N° SDA</span>
                            <div class="small">
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="sda" (keyup)="applyFilters()" />
                                    <button mat-icon-button matSuffix
                                        (click)="resetColumnFilter('sda')"><mat-icon>clear</mat-icon></button>
                                </mat-form-field>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let ext">{{ ext.sdaNumber || '—' }}</td>
                    </ng-container>

                    <!-- Actif -->
                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef>Actif</th>

                        <td mat-cell *matCellDef="let ext">
                            <div class="status-icon" [class.active]="ext.enabled" [class.inactive]="!ext.enabled">
                                <mat-icon>
                                    {{ ext.enabled ? 'check_circle' : 'cancel' }}
                                </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>Actions</th>
                        <td mat-cell *matCellDef="let ext">
                            <div class="actions-cell">
                                <button mat-icon-button (click)="onView(ext)">
                                    <mat-icon>visibility</mat-icon>
                                </button>
                                @if (isFullAccess) {
                                <button mat-icon-button (click)="onEdit(ext)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>
        </form>
    </div>
</div>
<mat-paginator [pageSizeOptions]="[10, 25, 50]" showFirstLastButtons></mat-paginator>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="true"></ngx-spinner>